import { render, staticRenderFns } from "./BaseFormItem.vue?vue&type=template&id=0a318e1d&scoped=true"
import script from "./BaseFormItem.vue?vue&type=script&lang=js"
export * from "./BaseFormItem.vue?vue&type=script&lang=js"
import style0 from "./BaseFormItem.vue?vue&type=style&index=0&id=0a318e1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a318e1d",
  null
  
)

export default component.exports